export const FOOTER_HEIGHT = '56px';
export const HEADER_HEIGHT = '83px';
export const PROCESS_HEADER_HEIGHT = '54px';
export const BETA_BANNER_HEIGHT = '41px';
